<template>
  <div class="yunxiao teacher make-up make-attented">
    <div class="main">
      <van-form input-align="right">
        <div class="tips">将缺勤记录标记为已补课，不需要再进行安排补课、点名上课。</div>
        <van-cell title="上课老师" is-link @click="chooseTeacher">
          <template>
            <div v-if="params.teacherId">
              {{ params.teacherName }}
            </div>
            <div v-else style="color: var(--g5)">请选择</div>
          </template>
        </van-cell>
        <van-cell title="助教" is-link @click="choiceAssitantTeacher">
          <template>
            <div v-if="assistantTeacherText">
              {{ assistantTeacherText }}
            </div>
            <div v-else style="color: var(--g5)">请选择</div>
          </template>
        </van-cell>
        <van-cell title="补课日期" required	 is-link @click="chooseDate">
          <template>
            <div v-if="params.remedyTime">
              {{ params.remedyTime | formatDatetime('yyyy-MM-dd') }}
            </div>
            <div v-else style="color: var(--g5)">请选择</div>
          </template>
        </van-cell>
        <div class="block has-title-tips-field">
          <van-field name="radio" label="补课计费" :border="false">
            <template #input>
              <van-radio-group
                v-model="params.chargeEnable"
                direction="horizontal"
                :disabled="Boolean(detail.chargeStatus)"
              >
                <van-radio :name="1">计费</van-radio>
                <van-radio :name="0">不计费</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <p class="tips" v-if="detail.chargeStatus">缺勤排课已计费，标记补课不可重复计费</p>
          <p class="tips" v-else>缺勤排课未计费，标记补课可选择是否计费</p>

          <van-cell
            v-if="classHourList.length && params.chargeEnable == 1"
            title="本次扣费上课卡"
            title-class="tctil"
            :is-link="classHourList.length > 1"
            @click="openChooseCard"
            class="cus-cell"
          >
            <template>
              <div class="student-amount-item">
                <div class="name">
                  <span class="tag" :class="{ card: defaultClassHour.cardType == 1 }">{{
                    defaultClassHour.cardType == 0 ? '课程' : '课时包'
                  }}</span
                  >{{ defaultClassHour.name }}
                </div>
                <div class="amount">
                  <span class="label">剩余：</span>
                  <span :class="{ owe: defaultClassHour.remainTotalAmount < 0 }"
                    >{{
                      defaultClassHour.remainTotalAmount >= 0
                        ? defaultClassHour.remainTotalAmount
                        : 0
                    }}
                    <template v-if="defaultClassHour.remainTotalAmount < 0"
                      >(欠费{{ Math.abs(defaultClassHour.remainTotalAmount) }})</template
                    >
                  </span>
                  <span class="label">{{ lessonUnit }}</span>
                </div>
              </div>
            </template>
          </van-cell>
        </div>
        <div class="block">
          <!-- 备注 -->
          <van-field
            type="textarea"
            v-model="params.remark"
            autosize
            rows="3"
            maxlength="50"
            input-align="left"
            placeholder="请输入备注内容"
            show-word-limit
          />
        </div>
      </van-form>
    </div>
    <page-footer-btn multipleBtns>
      <van-button
        square
        round
        block
        type="primary"
        @click="submit"
        loading-text="保存中..."
        :loading="submiting"
        data-test="add-make-attended-btn-save"
      >
        确定
      </van-button>
    </page-footer-btn>
    <van-popup v-model="showDatePopup" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="datePopupConfirm"
        @cancel="showDatePopup = false"
      />
    </van-popup>
    <choose-course-card
      :value="openCardFlag"
      :list="classHourList"
      @close="openCardFlag = false"
      @submit="changeCourseCard"
    ></choose-course-card>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import chooseCourseCard from '../course-attend/children/choose-course-card.vue';

export default {
  name: 'makeUpMakeAttented',

  data() {
    return {
      pageTitle: '标记为已补课',
      submiting: false,
      showDatePopup: false,
      currentDate: new Date(),
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(),
      assistantTeacherList: [],
      params: {
        courseAbsentId: this.$vxRoute.query.id,
        assistantTeacherIds: [],
        teacherId: '',
        teacherName: '',
        remedyTime: '',
        chargeEnable: 1,
        remark: '',
        signCardCourseTradedId: '',
      },
      detail: {
        chargeStatus: 0,
      },
      openCardFlag: false,
      classHourList: [],
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    assistantTeacherText() {
      let cpc = this.assistantTeacherList;
      if (cpc.length == 1) {
        return cpc[0].name;
      } else if (cpc.length > 1) {
        return `${cpc.length}个助教`;
      }
      return '';
    },
    defaultClassHour() {
      return this.classHourList.find(item => item.defaultSignCard);
    },
  },
  methods: {
    changeCourseCard(index) {
      this.classHourList.forEach(item => (item.defaultSignCard = false));
      this.classHourList[index].defaultSignCard = true;
      this.params.signCardCourseTradedId = this.classHourList[index].cardCourseTradedId;
      this.openCardFlag = false;
    },
    openChooseCard() {
      if (this.classHourList.length > 1) {
        this.openCardFlag = true;
      }
    },
    // 选择老师
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        id: this.params.teacherId,
      });
      this.params.teacherId = res ? res.id : '';
      this.params.teacherName = res ? res.name : '';
    },
    // 选择上课老师
    async choiceAssitantTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.assistantTeacherIds,
        list: this.assistantTeacherList,
        params: {
          statusList: [1],
        },
      });
      this.params.assistantTeacherIds = res ? res.ids : [];
      this.assistantTeacherList = res ? res.list : [];
    },
    chooseDate() {
      this.showDatePopup = true;
    },
    async datePopupConfirm(date) {
      this.showDatePopup = false;
      this.params.remedyTime = date.getTime();
      const res = await this.$api.findStudentCurriculumCard({
        campusId: this.detail.campusId,
        curriculumId: this.detail.curriculumId,
        studentIds: [this.detail.studentId],
        courseTime: this.params.remedyTime,
      });

      if (res.data && res.data[0]) {
        this.classHourList = res.data[0].courseCard.classHourCardVoList;
        setTimeout(() => {
          this.params.signCardCourseTradedId = this.defaultClassHour.cardCourseTradedId;
        }, 0);
      }
    },
    submit() {
      if (this.params.chargeEnable == 1 && !this.params.remedyTime) {
        this.$toast('选择补课计费，补课日期不可为空');
        return;
      }
      this.submiting = true;
      let submitParams = { ...this.params };
      if (!submitParams.assistantTeacherIds.length) {
        delete submitParams.assistantTeacherIds;
      }
      this.$api
        .courseRemedyMark(submitParams)
        .then(res => {
          this.submiting = false;
          if (res.code === 200) {
            this.$toast.success('操作成功');
            app.vue.$emit('add-make-up-success');
            this.$router.back();
            return true;
          }
          if (res.code === 830000026) {
            vant.Dialog.confirm({
              title: '提示',
              allowHtml: true,
              message: `${this.detail.studentName} 扣费上课卡剩余数量不足，本次计费将产生欠费，请确认是否仍标记为已补课？`,
              confirmButtonText: '确认',
              messageAlign: 'left',
            }).then(()=>{
              this.params.markWhileChargeNotEnough = true;
              this.submit();
            }).catch(()=>{
              delete this.params.markWhileChargeNotEnough;
            })
            return;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err => {
          console.log(err);
          this.submiting = false;
          delete this.params.markWhileChargeNotEnough;
        });
    },
  },
  created() {
    this.showLoading();
    let { courseAbsentId } = this.params;
    this.$api
      .getCourseAbsent({ courseAbsentId })
      .then(res => {
        if (res.code === 200) {
          this.$toast.clear();
          this.detail = res.data;
          let { courseTeacherList, chargeStatus } = res.data || {};
          if (chargeStatus === 1) {
            this.params.chargeEnable = 0;
          }
          if (courseTeacherList && courseTeacherList[0] && courseTeacherList[0].id) {
            let { teacherName, teacherId } = courseTeacherList[0];
            this.params.teacherId = teacherId;
            this.params.teacherName = teacherName;
          }
        }
      })
      .catch(err => {
        this.$toast.clear();
        console.log(err);
      });
  },
  components: {
    pageFooterBtn,
    chooseCourseCard,
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.make-up.make-attented {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    color: var(--g6);
    .block {
      margin: calc(var(--gap) * 12) 0;
    }
    .student-amount-item {
      padding: calc(var(--gap) * 4) 0;
      // display: flex;
      // justify-content: space-between;
      .name {
        font-size: var(--fs-md);
        line-height: var(--lh-md);

        .tag {
          margin-right: calc(var(--gap) * 4);
          display: inline-block;
          font-weight: normal;
          padding: 0 calc(var(--gap) * 2);
          color: var(--white);
          background: var(--c1);
          border-radius: 2px;
          &.card {
            background-color: var(--c4);
          }
        }
      }
      .amount {
        flex-shrink: 0;
        .label {
          color: var(--g6);
        }
        .owe {
          color: var(--c3) !important;
        }
      }
    }

    .has-title-tips-field {
      padding-bottom: calc(var(--gap) * 16);
      background-color: var(--white);
      > .tips {
        margin: 0 calc(var(--gap) * 16);
      }
      > div {
        padding: 15px 16px 4px;
      }
    }
    .tips {
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
    }
  }
  ::v-deep.van-cell.disabled {
    .van-cell__value {
      color: var(--g6);
    }
    .van-cell__right-icon {
      color: var(--g5);
    }
  }
}
</style>
<style lang="scss">
.yunxiao.teacher.make-up.make-attented {
  .main {
    .van-cell__value,
    .van-cell__title,
    .van-field__label,
    .van-field__value {
      color: var(--g8);
    }
    .van-cell__label {
      white-space: nowrap;
    }
    .van-cell__title:not(.tctil),
    .van-field__label {
      color: var(--g7);
      flex: unset;
      width: calc(var(--w) * 80);
    }
  }
}
</style>